import * as actions from './Actions';

/**
 * Parse unit data to ensure consistent structure in the Redux store
 * @param {Object} unit - The unit data from API
 * @returns {Object} - Formatted unit object
 */
const parseUnit = (unit) => {
  if (!unit) return null;
  
  return {
    unit_id: unit.unit_id,
    // Handle both field naming conventions (API response vs direct add)
    code: unit.unit_code || unit.code || '',
    title: unit.specific_unit || unit.title || '',
    discipline_id: unit.discipline_id !== undefined ? parseInt(unit.discipline_id, 10) : (unit.disciplineId !== undefined ? parseInt(unit.disciplineId, 10) : 0),
    createdAt: unit.createdAt || new Date().toISOString(),
    updatedAt: unit.updatedAt || new Date().toISOString(),
    skills: unit.skills || []
  };
};

const initialState = [];

const UnitReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.INITIALIZE_UNITS:
      return action.payload.map(unit => parseUnit(unit));
      
    case actions.ADD_UNIT:
      // Check if unit with the same ID already exists to prevent duplicates
      const unitExists = state.some(u => u.unit_id === action.payload.unit_id);
      
      if (unitExists) {
        // Skip adding duplicate unit
        return state;
      }
      
      // Add new unit to the state
      return [...state, parseUnit(action.payload)];
      
    case actions.UPDATE_UNIT:
      // Update an existing unit
      return state.map(unit => 
        unit.unit_id === action.payload.unit_id 
        ? parseUnit(action.payload) 
        : unit
      );
      
    case actions.DELETE_UNIT:
      // Remove a unit by ID
      return state.filter(unit => unit.unit_id !== action.payload);
      
    case actions.CLEAR_UNITS_LIST:
      // Reset to initial state
      return initialState;
      
    default:
      return state;
  }
};

export default UnitReducer;
